import { render, staticRenderFns } from "./HouseKeeping.vue?vue&type=template&id=a1172ba2"
import script from "./HouseKeeping.vue?vue&type=script&lang=js"
export * from "./HouseKeeping.vue?vue&type=script&lang=js"
import style0 from "./HouseKeeping.vue?vue&type=style&index=0&id=a1172ba2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports